// @flow

import React from 'react';
import {Checkbox, Form} from 'antd';
import type {History, Location} from 'react-router';

import data from '../data/heroes.js';
import {withRouter} from 'react-router-dom';
import params from '../utils/team_optimizer_params';
import type {Hero} from '../data/heroes';

type Props = {
  history: History,
  location: Location
};

function TeamOptimizerOptions({history, location}: Props) {
  const {requiredHeroes, optionalHeroes} = params.get(location);
  return <div>
    <div>
      <Form
        name="Options"
        initialValues={{
          remember: true,
        }}
      >
        <Form.Item
          label="Required Heroes (Heroes who must be in the team)"
          name="require_heroes"
        >
          <div>
            <Checkbox.Group
              options={data.map((hero: Hero) => {
                return {
                  label: hero.name,
                  value: hero.name,
                };
              })}
              value={requiredHeroes.map((hero: Hero) => hero.name)}
              onChange={(heroes: Array<Hero>) => {
                const requiredHeroes = data.filter(
                  (hero: Hero) => heroes.includes(hero.name),
                );
                params.update(history, {
                  requiredHeroes,
                  optionalHeroes,
                });
              }}/>
          </div>
        </Form.Item>
        <Form.Item
          label="Optional Heroes (Candidates to be selected by optimatizer)"
          name="username"
        >
          <div>
            <Checkbox
              checked={optionalHeroes.length === data.length}
              onChange={(e) => {
                if (e.target.checked) {
                  const q = params.update(
                    history, {requiredHeroes, optionalHeroes: data},
                  );
                  localStorage.setItem('team_optimizer_options', q);
                } else {
                  const q = params.update(
                    history, {requiredHeroes, optionalHeroes: []},
                  );
                  localStorage.setItem('team_optimizer_options', q);
                }
              }}>Select All</Checkbox>
            <Checkbox.Group
              options={data.map((hero: Hero) => {
                return {
                  label: hero.name,
                  value: hero.name,
                  disabled: requiredHeroes.map((h: Hero) => h.name)
                    .includes(hero.name),
                };
              })}
              value={optionalHeroes.map((hero: Hero) => hero.name)}
              onChange={(heroes) => {
                const q = params.update(history, {
                  requiredHeroes,
                  optionalHeroes: data.filter(
                    (hero: Hero) => heroes.includes(hero.name),
                  ),
                });
                localStorage.setItem('team_optimizer_options', q);
              }}/>
          </div>
        </Form.Item>
      </Form>
    </div>
  </div>;
}

export default withRouter(TeamOptimizerOptions);
